const initOurTeamLeadershipSections = () => {
    [...document.querySelectorAll('.our-team-leadership-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initOurTeamLeadershipSection(item));
};

const initOurTeamLeadershipSection = (section) => {
    section.dataset.init = true;
    const readMoreButtons = section.querySelectorAll('.read-more');


    readMoreButtons.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const item = btn.closest('.item');
            const detail = item?.querySelector('.detail-information');
            const teamOverlay = document.querySelector('.overlay-team');
            if (!detail) return;

            detail.style.display = 'block';
            requestAnimationFrame(() => {
                detail.classList.add('active');
                teamOverlay.classList.add('active');
            });

            const closeDetail = (event) => {
                if (
                    event.target === detail ||
                    event.target.closest('.close')
                ) {
                    detail.classList.remove('active');
                    teamOverlay.classList.remove('active');
                    detail.addEventListener(
                        'transitionend',
                        () => (detail.style.display = 'none'),
                        { once: true }
                    );
                    document.removeEventListener('click', closeDetail);
                }
            };
            document.addEventListener('click', closeDetail);
        });
    });
};

export { initOurTeamLeadershipSections };